import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ColumnOptions } from '../../models';
import { ColumnComponent, FilterService } from '@progress/kendo-angular-grid';
import { CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query';

@Component({
  selector: 'app-filter-menu',
  templateUrl: './filter-menu.component.html',
  styleUrl: './filter-menu.component.scss',
})
export class FilterMenuComponent {
  @Input()
  column!: ColumnOptions;

  @Input()
  gridColumn!: ColumnComponent;

  @Input()
  filterService!: FilterService;

  @Input()
  filter!: CompositeFilterDescriptor;

  get multiselectValue(): { name: string; value: any }[] {
    const field = this.column.filterField ?? this.column.field;
    const options = this.column.filterOptions || [];
    const activeValues = (this.filter?.filters || [])
      .filter((f): f is FilterDescriptor => 'field' in f && (f as FilterDescriptor).field === field)
      .map((f) => (f as FilterDescriptor).value);
    return options.filter((o) => activeValues.includes(o.value));
  }

  get booleanValue(): { name: string; value: any } | undefined {
    const field = this.column.filterField ?? this.column.field;
    const options = this.column.filterOptions || [
      { name: 'Yes', value: true },
      { name: 'No', value: false },
    ];
    const activeFilter = (this.filter?.filters || [])
      .find((f): f is FilterDescriptor => 'field' in f && (f as FilterDescriptor).field === field);
    if (!activeFilter) return undefined;
    return options.find((o) => o.value === activeFilter.value);
  }

  @Output()
  customFilterChange: EventEmitter<{
    column: ColumnOptions;
    filter: CompositeFilterDescriptor;
    filterService: FilterService;
  }> = new EventEmitter<{
    column: ColumnOptions;
    filter: CompositeFilterDescriptor;
    filterService: FilterService;
  }>();

  onCustomFilterChange($event: CompositeFilterDescriptor) {
    this.customFilterChange.emit({
      column: this.column,
      filter: $event,
      filterService: this.filterService,
    });
  }

  onMultiselectFilterChange(values: { name: string; value: any }[]) {
    this.filterService.filter({
      filters: values.map((v) => ({
        field: this.column.filterField ?? this.column.field,
        operator: 'eq',
        value: v.value,
      })),
      logic: 'or',
    });
  }
}
